import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { ModelProfileList } from './ModelProfileList'

/** 旧链接 /manage/models/:type/:provider 重定向回列表（编辑改弹框） */
function LegacyProviderRedirect() {
  const { modelType } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    void navigate(`/manage/models/${modelType || 'llm'}`, { replace: true })
  }, [modelType, navigate])
  return null
}

export default function ModelSettings() {
  return (
    <Routes>
      <Route index element={<Navigate to="llm" replace />} />
      <Route path=":modelType/:providerId" element={<LegacyProviderRedirect />} />
      <Route path=":modelType" element={<ModelProfileList />} />
    </Routes>
  )
}
